import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import arrowOutlined from "@/assets/arrow-outlined.svg";
import { Icon } from "@/elements-react/fix-icon";
import { FixButton } from "@/elements-react/fix-button";
import FixBackButton from "@/elements-react/fix-back-button";

export interface DialogMobileProps {
  label: string;
  type?: string;
  fullsize?: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
}

export const DialogMobile: React.FC<DialogMobileProps> = ({ label, type, fullsize, onClose, children }) => {
  return (
    <div className={classNames(styles.root, styles.dialog, type && styles[type], fullsize && styles.fullsize)}>
      <div className={styles.header}>
        <FixBackButton onClick={onClose}>
          <Icon src={arrowOutlined} />
          <span>Back</span>
        </FixBackButton>
        <div className={styles.label}>{label}</div>
      </div>
      <div className={styles.container}>{children}</div>
    </div>
  );
};
